import { FC, useState } from 'react'

import clsx from 'clsx'

import { RealtyType } from 'shared/api/kyrgyzstan/search'

import s from './styles.module.scss'

interface TypeTagProps {
  type: RealtyType
  className?: string
}

export const TypeTag: FC<TypeTagProps> = ({ type, className }) => {
  const [imageError, setImageError] = useState(false)

  return (
    <div className={clsx(s.tag, className)}>
      {type.icon && !imageError && (
        <div className={s.iconContainer}>
          <img
            src={type.icon}
            alt={type.name}
            className={s.icon}
            loading="lazy"
            decoding="async"
            onError={() => setImageError(true)}
          />
        </div>
      )}
      <span className={clsx('semi-bold-11', s.name)}>{type.name}</span>
    </div>
  )
}
